import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import CardSummary from '../AdyenPaymentCardSummary.js';

const BancontactSummary = (props)=>/*#__PURE__*/ React.createElement(CardSummary, swcHelpers.extends({}, props))
;
var BancontactSummary$1 = BancontactSummary;

export { BancontactSummary$1 as default };
//# sourceMappingURL=BancontactSummary.js.map
